// extracted by mini-css-extract-plugin
module.exports = {"_banner":"EnvironmentBanner__banner__2kLav"};